/**
 * Strips a leading site code (e.g. "F01014") from Coveo/Sitecore site names
 * so only the human-readable name is displayed.
 */
export function refineSiteName(siteName: string | null | undefined): string {
  if (!siteName) {
    return '';
  }

  return siteName.replace(/^[A-Za-z]\d+\s+/, '').trim();
}
